import React from 'react';
import { Flex } from 'rebass';
import { Input, InputProps } from '@rebass/forms';
import Icon from '../Icon/Icon';
import colors from '../../theme/colors';
import { FormComboGroup } from './FormComboGroup';

const SearchInput = (props: InputProps): JSX.Element => {
  return (
    <FormComboGroup
      ml={props.ml}
      mr={props.mr}
      sx={{
        ':hover:not(:focus-within)': {
          'div, input': {
            borderColor: 'black',
          },
        },
        // ':focus-within': {
        //   borderColor: 'primary',
        //   outline: 'none',
        //   boxShadow: (t: Theme) => `0 0 0 1px ${t.colors.primary}`,
        //   zIndex: '999998',
        // },
      }}
    >
      <Input
        type="search"
        variant="inputRoundedLeft"
        {...(props as any)}
        ml={undefined}
        mr={undefined}
        pr={0}
        autoComplete="off"
      />
      <Flex
        alignItems="center"
        bg="white"
        sx={{
          borderTopRightRadius: 'circle',
          borderBottomRightRadius: 'circle',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: 'fieldBorder',
          borderLeftWidth: 0,
          pl: 1,
          pr: 2,
        }}
      >
        <Icon icon="search" color={colors.fieldBorderHover} size="14" />
      </Flex>
    </FormComboGroup>
  );
};

export { SearchInput };
